<template>
    <div class="order-pictures">
        <p>写真、動画を撮影してください</p>
        <ul>
            <li v-for='(image, index) in images' :key='index'>
                <label class='picture-uploader'
                       :class='isImageAvailable(index) ? "":"blank"'>
                    <input type="file" accept="image/*"
                           @change='selectedFile(index, $event)'/>
                    <Icon icon='camera'/>
                    <img v-if='isImageAvailable(index)'
                         :src="dataurl_images[index] || image" alt=""/>
                </label>
            </li>
        </ul>
        <div class="confirm-info">
            撮影した写真をホームページに利用させていただくことがございます。<br>
            お客さまにも撮影した画像が利用されても問題ないかの確認をしたうえで保存してください。
        </div>
        <div class="floating-actions">
            <button class="btn" type='button'
                    :disabled='file_images.length === 0 || loading'
                    @click='save'>
                保存
            </button>
        </div>
    </div>
</template>

<script>
import ResizeImage
    from '@/lib/resizeImage'

export default {
    props: ['step', 'order'],
    name: "WorkPictures",
    data: function () {
        let step_num = this.step === 'before' ? 1 : 2;
        let images = this.order ? this.order.info_steps[step_num].images : null;
        if (images != null) {
            images[0] = images[0] || '';
            images[1] = images[1] || '';
            images[2] = images[2] || '';
            images.length = 3;
        }
        return {
            images: images,
            dataurl_images: ['', '', ''],
            file_images: [],
            loading: false,
        }
    },
    methods: {
        isImageAvailable: function (index) {
            return this.images[index].length || this.dataurl_images[index].length;
        },
        async selectedFile(index, e) {
            this.$$.load();

            const file = e.target.files[0];
            if (!file) {
                return;
            }

            try {
                // 圧縮した画像を取得
                const compFile = await ResizeImage.getCompressImageFileAsync(file);
                // 画像情報の設定
                this.processFile(index, compFile);
            } catch (err) {
                // エラーメッセージ等を表示
            } finally {
                this.$$.endload();
            }
        },
        processFile: function (index, image) {
            this.$set(this.images, index, image)
            this.$set(this.file_images, index, image)

            let reader = new FileReader()
            reader.onloadend = () => {
                this.$set(this.dataurl_images, index, reader.result)
            };
            reader.readAsDataURL(image)

        },
        save: function () {
            this.loading = true;

            let picSender =
                this.step === 'before' ?
                    this.$api.postOrderBeforeWorkPictures :
                    this.$api.postOrderAfterWorkPictures;

            picSender(this.$route.params.id, this.file_images)
                .then((res) => {
                    this.loading = false;
                    this.$$.flash();

                    this.order.info_steps = res.data.data.info_steps;
                    this.$router.push({name: 'orderSteps'});
                })
                .catch(() => {
                    this.loading = false;
                })
        }
    },
    created: function () {
        if (!this.images) this.$router.push({name: 'orderSteps'})
    },
    mounted: function () {
        this.$$.context({
            previous: 'トップへ',
            title: "ID:" + this.$route.params.id,
            previousRouteName: 'orderSteps',
        });
    }
}
</script>

<style lang='scss'>
.order-pictures {
    &__upload {
        padding: 1em;
        text-align: center;
    }

    ul {
        display: flex;
        margin-bottom: 20px;

        li {
            width: 33.33%;
            padding: 24px 8px;
            background: #fafafa;
            min-height: 200px;
        }
    }

    p {
        text-align: left;
        padding: 4px 16px;
        font-size: 12px;
        color: #888;
        background: #eee;
    }

    .confirm-info {
        font-size: 16px;
        font-weight: 600;
        color: #1b2b3a;
        margin: 0 15px;
        padding: 12px 14px 12px 48px;
        border: 1px solid #dcebf7;
        border-left: 6px solid #4a90e2;
        border-radius: 10px;
        background: linear-gradient(180deg, #f7fbff, #f3f8ff);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
        position: relative;
    }

    .confirm-info::before {
        content: '\2139';
        position: absolute;
        left: 18px;
        top: 50%;
        transform: translateY(-50%);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: #4a90e2;
        color: #fff;
        font-weight: 700;
        font-size: 13px;
    }
}
</style>
